import React, { useState, useEffect, FC } from 'react';
import { useMedia } from 'react-use';
import { Logo } from './components/Logo/Logo';
import { NavProfile } from './components/NavProfile/NavProfile';
import { NavMenu } from './components/NavMenu/NavMenu';
import { Notification } from './components/Notification/Notification';
import { postRequest } from '../../utils/request';
import { ReactComponent as BurgerIcon } from '../../assets/icons/burger.svg';
import { ReactComponent as CloseIcon } from '../../assets/icons/commons/close.svg';
import styles from './Header.module.css';
import { ConfirmLogout } from './components/ConfirmLogout/ConfirmLogout';
import {
  DEFAULT_AUTH_HOST,
  DEFAULT_ONEID_HOST,
  mobileWidthSize
} from '../../utils/constants';
import { generateEnvDomain } from '../../utils/generateEnvDomain';
import { NavMenuMobile } from "./components/NavMenu/NavMenu";
import { IHeader, INavItems } from "../../declarations/types";
import { setUnioneToken } from "../../utils/setUnioneToken";
import { getUnioneToken } from "../../utils/getUnioneToken";
import { setS3Token } from "../../utils/setS3Token";
import { getS3Token } from "../../utils/getS3Token";
import { removeUnioneToken } from "../../utils/removeUnioneToken";
import { goToAuth } from "../../utils/goToAuth";
import { goToLogout } from "../../utils/goToLogout";
import { getVersion } from "../../utils/getVersion";
import cn from "classnames";

if (window) {
  window.unione = {
    setUnioneToken,
    getUnioneToken,
    removeUnioneToken,
    goToAuth,
    goToLogout,
    getVersion,
    setS3Token,
    getS3Token,
  };
}

export const Header: FC<IHeader> = ({
  userName: userNameProps,
  isDark,
  isNavBarHidden,
}) => {
  const conversion = '_thumb.jpg'
  let isMobileInner = useMedia('(max-width: 1340px)');

  const [openedMobile, setOpenedMobile] = useState(false);
  const [stateNavItems, setStateNavItems] = useState<INavItems[] | undefined>(undefined);
  const [isAuth, setIsAuth] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [openNotification, setOpenNotification] = useState(false);
  const [openConfirmLogout, setOpenConfirmLogout] = useState(false);
  const [userFullName, setUserFullName] = useState<string | null>(null);
  const [userImage, setUserImage] = useState<string | null>(null);
  const [changeUserData, setChangeUserData] = useState(false);
  const [s3Token, setS3Token] = useState<undefined | string>();

  const checkService = (): string => {
    const siteUrl = window.location.hostname;
    const regex = /^[A-Za-z0-9](?:[A-Za-z0-9\-]{0,61}[A-Za-z0-9])?/; // добавь еще "m" если хотите, чтобы работало для мультистрок
    const res = regex.exec(siteUrl);
    return String(res);
  }

  useEffect(() => {
    if (!window.location.origin.includes('auth')) {
      const authHost = generateEnvDomain(DEFAULT_AUTH_HOST);
      const oneIdHost = generateEnvDomain(DEFAULT_ONEID_HOST);

      getUnioneToken()
        .then((token) => {
          if (token !== null && token !== 'null' && token !== undefined && token !== '') {
            return postRequest('/getuserdata', JSON.stringify({ token }), {}, `${authHost}/api/v1`)
          }
        })
        .then((response) => {
          getS3Token().then((token) => {
            if (token) {
              setS3Token(token);
            }
          }).catch(() => {
            console.error('S3Token error');
          });
          if (!response.need_fields && !window.location.origin.includes('oneid')) {
            const encodeUrl = encodeURIComponent(window.location.href);
            window.location.href = `${oneIdHost}?redirect=${encodeUrl}`;
            return;
          }
          if (response.values && response.values.length > 0) {
            const { name, sur_name: surname, patronymic } = response.values[0].user_info.passport;
            const { avatar } = response.values[0];

            if (avatar) {
              const separated = avatar.split('.');
              const miniatureImg = `${separated[0] + conversion}`;
              setUserImage(`${miniatureImg}`);
            }
            setUserFullName(`${surname} ${name} ${patronymic}`);
            setIsAuth(true);
          }
        }, (error) => {
          console.error(error);
        })
        .catch((error) => {
          throw Error(error);
        });
    }
  }, [changeUserData]);

  useEffect(() => {
    document.addEventListener('openNotification', showGoToAuthModal);

    return () => document.removeEventListener('openNotification', showGoToAuthModal);
  }, []);

  useEffect(() => {
    document.addEventListener('openConfirmLogoutNotification', showConfirmLogoutModal);

    return () => document.removeEventListener('openConfirmLogoutNotification', showConfirmLogoutModal);
  }, []);

  useEffect(() => {
    document.addEventListener('updateUserData', changeUserDataFunc);

    return () => document.removeEventListener('updateUserData', changeUserDataFunc);
  }, []);

  useEffect(() => {
    postRequest('/getheader', JSON.stringify({service: checkService()}) ,{})
      .then((data) => {
        if (data.values && Array.isArray(data.values) && data.values.length > 0) {
          setStateNavItems(data.values);
          setTimeout(() => {
            setIsLoading(true);
          }, 100);
        }
      }, (error) => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://lib.usedesk.ru/secure.usedesk.ru/widget_162677_41939.js';
    script.async = true;

    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const yandexMetrikaScript = document.createElement('script');
    yandexMetrikaScript.type = 'text/javascript';
    yandexMetrikaScript.async = true;
    yandexMetrikaScript.innerHTML = `
    (function(m,e,t,r,i,k,a){
      m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) { return; }
      }
      k=e.createElement(t), a=e.getElementsByTagName(t)[0];
      k.async=1;
      k.src=r;
      a.parentNode.insertBefore(k,a);
    })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

    ym(88151482, "init", {
      clickmap:true,
      trackLinks:true,
      accurateTrackBounce:true
    });
  `;
    document.body.appendChild(yandexMetrikaScript);

    return () => {
      document.body.removeChild(yandexMetrikaScript);
    };
  }, []);

  const changeUserDataFunc = () => {
    setChangeUserData(true);
  };

  const showGoToAuthModal = () => {
    setOpenNotification(true);
  };

  const showConfirmLogoutModal = () => {
    setOpenConfirmLogout(true);
  };

  const handleBurgerClick = () => {
    setOpenedMobile((prev) => !prev);
  };

  const handleLoginClick = (isEnter: boolean) => {
    goToAuth(isEnter);
  };

  const handleConfirmLogoutShow = () => {
    setOpenedMobile(false);
    setOpenConfirmLogout(true);
  };

  const styles_commons_header: string = cn(styles.commonsHeader, { [styles.commonsHeaderHeader]: isDark });

  const handleResize = () => {
    if (openedMobile && window.innerWidth > mobileWidthSize) {
      setOpenedMobile(false);
      document.body.style.overflow = 'auto';
    } else if (openedMobile && window.innerWidth <= mobileWidthSize) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [openedMobile]);

  return (
    <>
      <header className={styles_commons_header}>
        <a href={stateNavItems && stateNavItems[0].route}>
          <Logo />
        </a>

        {!isMobileInner && isLoading && !isNavBarHidden && (
          <NavMenu
            items={stateNavItems}
            isAuth={isAuth}
            isDark={isDark}
          />
        )}

        {!isMobileInner && isLoading && (
          <NavProfile
            photoUrl={userImage}
            userName={userFullName}
            isAuth={isAuth}
            onLogout={handleConfirmLogoutShow}
            onLogin={handleLoginClick}
            userFullName={userNameProps}
            isDark={isDark}
            s3Token={s3Token}
          />
        )}

        {isMobileInner && (
          <button
            type="button"
            className={styles.mobileBtn}
            onClick={handleBurgerClick}
          >
            {
              openedMobile ? <CloseIcon/> : <BurgerIcon />
            }
          </button>
        )}

        {openNotification && (<Notification />)}

        {openConfirmLogout && (
          <ConfirmLogout
            setOpenConfirmLogout={setOpenConfirmLogout}
            onLogout={goToLogout}
          />
        )}
      </header>

      {openedMobile && (
        <NavMenuMobile
          photoUrl={userImage}
          userName={userFullName}
          userFullName={userNameProps}
          items={stateNavItems}
          isAuth={isAuth}
          isNavBarHidden={isNavBarHidden}
          onLogout={handleConfirmLogoutShow}
          onLogin={handleLoginClick}
          isDark={isDark}
          s3Token={s3Token}
        />
      )}
    </>
  );
};
